import { Stack, Switch, Text } from "@chakra-ui/react";

export interface NotificationPreferenceFormItemProps {
  id: string;
  title: string;
  description: string;

  name: "email_enabled" | "push_notifications";
  isActive: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}
export const NotificationPreferenceFormItem = ({
  id,
  title,
  description,
  isActive,
  name,
  onChange,
}: NotificationPreferenceFormItemProps) => (
  <Stack justify="space-between" direction="row" spacing="4">
    <Stack spacing="0.5" fontSize="sm">
      <Text color="emphasized" fontWeight="medium">
        {title}
      </Text>
      <Text color="muted">{description}</Text>
    </Stack>
    <Switch
      id={id}
      isChecked={isActive}
      onChange={onChange}
      name={name}
      colorScheme="green"
    />
  </Stack>
);
